module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "scroller",
    staticClass: "load-more",
    style: (_vm.scrollerStyle)
  }, [(_vm.showLoadingWhale) ? [_c('animation-loading-whale', {
    staticClass: "whale-wrap",
    attrs: {
      "center": false,
      "loading": _vm.isLoading
    }
  })] : _vm._e(), _vm._v(" "), _vm._t("before-list"), _vm._v(" "), _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index
    }, [_vm._t("default", null, {
      item: item,
      index: index,
      list: _vm.list
    })], 2)
  }), _vm._v(" "), (!_vm.isLoading) ? [(_vm.hasMore) ? [(_vm.$slots.loading) ? _vm._t("loading") : _c('AnimationLoadmore', {
    attrs: {
      "circleFm": {
        background: _vm.theme
      }
    }
  })] : [(_vm.list.length === 0) ? _c('div', [(_vm.$slots.none) ? _vm._t("none") : _c('div', {
    staticClass: "no-more"
  }, [_vm._v("暂无数据")])], 2) : [(_vm.$slots.noMore) ? _vm._t("noMore") : _c('div', {
    staticClass: "no-more"
  }, [_vm._v("已全部展示")])]]] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-47135230!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoadMore.vue
// module id = 2521
// module chunks = 115